import React, { useState } from "react";
import { Accordion } from "react-bootstrap";

function PrescriptionPastAccordian({
  currentId,
  prescriptions,
  prescriptionData,
}) {
  return (
    <>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div>
              <h4 style={{ flex: "1" }}>
                Prescription for {currentId} written by{" "}
                {prescriptionData?.user?.first_name}
              </h4>
              <div>
                {prescriptionData?.order?.order_meta?.line_items.map(
                  (item, index) => {
                    return <span key={index}>{item?.title}</span>;
                  }
                )}
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              <div className="d-flex border my-1 border rounded">
                <p className="flex-1 m-0 p-2 border">Medicine</p>
                <p className="flex-1 m-0 p-2 border">Dosage</p>
                <p className="flex-1 m-0 p-2 border">Notes</p>
              </div>
              {prescriptions.map((prescription, index) => {
                return (
                  <div
                    key={index}
                    className="d-flex border my-1 border rounded"
                  >
                    <p className="flex-1 m-0 p-2 border">
                      {prescription.Medicine}
                    </p>
                    <p className="flex-1 m-0 p-2 border">
                      {prescription.Dosage}
                    </p>
                    <p className="flex-1 m-0 p-2 border">
                      {prescription?.note}
                    </p>
                  </div>
                );
              })}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default PrescriptionPastAccordian;
